import { Component, OnInit } from '@angular/core';
import { JsonDataService } from 'src/app/services/json-data.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'report-generator',
    templateUrl: './report-generator.component.html',
    styleUrls: ['./report-generator.component.css']
})
export class ReportGenerator implements OnInit {

    userId: string = this.userDetailService.userId;
    moduleId: string = 'BMZ011';
    moduleName = this.jsonDataService.data.moduleList.filter((data: any) => { return data.moduleId === 'BMZ011' })[0].moduleDesc;

    constructor(
        private jsonDataService: JsonDataService,
        private userDetailService: UserDetailsService,
    ) { }

    ngOnInit(): void {
        try {

        } catch (e) {
            console.error('Error initializing component:', e);
        }
    }

    triggerUrl(): string {
        const currentDate = new Date();
        const datePipe = new DatePipe('en-US');
        const formattedDate = datePipe.transform(currentDate, 'yyyy-MM-dd HH:mm:ss');
        const userName = this.userDetailService.name;
        const email = this.userDetailService.email;
        const hostname = window.location.hostname;
        let baseUrl = '';

        const rawEmail = email || '';
        const encodedUserId = encodeURIComponent(this.userId || '');

        if (hostname === 'admin.osp-devt.com') {
            baseUrl = `https://api-uat.bpims.com/tools/reports/portal-dev.php?u=${rawEmail}&userId=${encodedUserId}`;
        } else if (hostname === 'admin.osp-test.com') {
            baseUrl = `https://api-uat.bpims.com/tools/reports/portal-uat.php?u=${rawEmail}&userId=${encodedUserId}`;
        } else if (hostname === 'admin.express-protect.com') {
            baseUrl = `https://fes.bpimsapps.com/tools/reports/portal.php?u=${rawEmail}&userId=${encodedUserId}`; // Must change the URL in production
        } else {
            console.error('Unknown hostname:', hostname);
            return '';
        }

        return baseUrl;
    }

    onButtonClick(): void {
        const url = this.triggerUrl();
        if (url) {
            window.open(url, '_blank');
        } else {
            console.error('Failed to determine the URL.');
        }
    }
}
